// LeadStatusChip — чип статуса лида (V12 U-34-E): цвет + локализованная подпись.
// Единый источник цвета/подписи для списка лидов и карточки (DRY).

import { Chip } from '@mui/material';
import type { LeadStatus } from '@/api/leads';
import { formatLeadStatus } from '@/lib/format';
import { t } from '@/i18n';

/** Цвет чипа по статусу (контраст по смыслу: новый — info, в работе — warning, конвертирован — success). */
export function statusColor(status: LeadStatus): 'info' | 'warning' | 'success' | 'default' {
  switch (status) {
    case 'NEW':
      return 'info';
    case 'IN_PROGRESS':
      return 'warning';
    case 'CONVERTED':
      return 'success';
    case 'DISCARDED':
      return 'default';
  }
}

/** Чип статуса лида (используется в списке и карточке; label — i18n `leads.status.*`). */
export function LeadStatusChip({ status }: { status: LeadStatus }): JSX.Element {
  return <Chip size="small" color={statusColor(status)} label={formatLeadStatus(status, t)} />;
}
